import { GetCanDeleteSourceDataEvent, GetCanDeleteSourceDataEventResponse } from "@/api/dtos";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetCanDeleteSourceDataEventResponse, GetCanDeleteSourceDataEventResponse>) => response?.data?.canDelete;
const getError = (response?: SWRResponse<GetCanDeleteSourceDataEventResponse, GetCanDeleteSourceDataEventResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetCanDeleteSourceDataEventResponse, GetCanDeleteSourceDataEventResponse>) => ({});

export const useDeleteSourceDataEvent = (sourceDataEventId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!sourceDataEventId) {
            return undefined;
        }

        return () => {
            return new GetCanDeleteSourceDataEvent({ sourceDataEventId });
        }
    }, [sourceDataEventId]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useDeleteSourceDataEvent;